import React from "react";

const defaultApplicationFeatures = {};
export const ApplicationFeaturesContext = React.createContext(defaultApplicationFeatures);
